(function () {
  'use strict';

  /* ------------------------------------------------------------------ menu */
  var drawer = document.getElementById('menu-drawer');
  var overlay = document.querySelector('.menu-drawer__overlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  }
  document.querySelectorAll('[data-drawer-toggle]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

  /* --------------------------------------------------------------- gallery */
  function initGallery() {
    var mainImages = document.querySelectorAll('.shop-main-image');
    var thumbnails = document.querySelectorAll('.shop-thumbnail');
    var prevArrow = document.getElementById('main-prev-arrow');
    var nextArrow = document.getElementById('main-next-arrow');
    if (!mainImages.length) return;
    var total = mainImages.length;
    var currentIndex = 0;

    function setActive(index) {
      mainImages.forEach(function (img) { img.classList.remove('active'); });
      mainImages[index].classList.add('active');
      thumbnails.forEach(function (t) { t.classList.remove('active'); });
      if (thumbnails[index]) thumbnails[index].classList.add('active');
      currentIndex = index;
      var container = document.getElementById('thumbnail-container');
      var thumb = thumbnails[index];
      if (container && thumb) {
        container.scrollTo({
          left: thumb.offsetLeft - container.offsetWidth / 2 + thumb.offsetWidth / 2,
          behavior: 'smooth'
        });
      }
    }

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActive(parseInt(this.getAttribute('data-index'), 10) || 0);
      });
    });
    if (prevArrow) prevArrow.addEventListener('click', function () {
      setActive(currentIndex - 1 < 0 ? total - 1 : currentIndex - 1);
    });
    if (nextArrow) nextArrow.addEventListener('click', function () {
      setActive(currentIndex + 1 >= total ? 0 : currentIndex + 1);
    });
    setActive(0);
  }

  /* ------------------------------------------------------------------- faq */
  function initFaq() {
    document.querySelectorAll('.product-faq .faq-item').forEach(function (item) {
      var q = item.querySelector('.faq-question');
      if (!q) return;
      q.addEventListener('click', function () { item.classList.toggle('active'); });
    });
  }

  /* --------------------------------------------------------------- bundles */
  function initBundles() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var variantInput = form.querySelector('[data-variant-input]');
    var qtyInput = form.querySelector('[data-quantity-input]');
    var planInput = form.querySelector('[data-selling-plan-input]');
    var bundles = document.querySelectorAll('[data-bundle]');
    var subOptions = document.querySelectorAll('[data-sub-option]');

    function subscriptionOn() {
      var checked = document.querySelector('input[name="mt-purchase-type"]:checked');
      return checked ? checked.value === 'subscribe' : false;
    }

    function selectedBundle() {
      return document.querySelector('[data-bundle].is-selected') || bundles[0] || null;
    }

    function sync() {
      var bundle = selectedBundle();
      var sub = subscriptionOn();

      bundles.forEach(function (b) {
        var priceEl = b.querySelector('[data-bundle-price]');
        if (!priceEl) return;
        var one = b.getAttribute('data-price') || '';
        var subPrice = b.getAttribute('data-sub-price') || '';
        priceEl.textContent = (sub && subPrice) ? subPrice : one;
      });

      if (!bundle) return;
      if (variantInput) variantInput.value = bundle.getAttribute('data-variant-id') || variantInput.value;
      if (qtyInput) qtyInput.value = bundle.getAttribute('data-qty') || '1';
      if (planInput) {
        var plan = bundle.getAttribute('data-selling-plan');
        if (sub && plan) {
          planInput.value = plan;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }
    }

    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        bundles.forEach(function (x) { x.classList.remove('is-selected'); });
        b.classList.add('is-selected');
        var radio = b.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        sync();
      });
    });

    subOptions.forEach(function (o) {
      o.addEventListener('click', function () {
        subOptions.forEach(function (x) { x.classList.remove('is-selected'); });
        o.classList.add('is-selected');
        var radio = o.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        sync();
      });
    });

    if (bundles.length && !document.querySelector('[data-bundle].is-selected')) {
      bundles[0].classList.add('is-selected');
    }
    sync();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('[data-add-button]');
      var original = button ? button.querySelector('.button-text').textContent : '';
      if (button) { button.disabled = true; button.querySelector('.button-text').textContent = 'Aggiungo…'; }

      var body = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () {
          if (button) { button.disabled = false; button.querySelector('.button-text').textContent = original; }
        });
    });
  }

  /* ---------------------------------------------------------- cart drawer */
  var cartDrawer = document.getElementById('CartDrawer');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function money(cents) {
    var format = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var value = (cents / 100).toFixed(2);
    if (format === 'USD') return '$' + value;
    if (format === 'GBP') return '\u00a3' + value;
    return value.replace('.', ',') + ' \u20ac';
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = document.querySelector('[data-cart-body]');
        var foot = document.querySelector('[data-cart-foot]');
        var totalEl = document.querySelector('[data-cart-total]');
        var count = document.querySelector('[data-cart-count]');
        if (count) count.textContent = cart.item_count;
        if (!body) return cart;

        if (!cart.items.length) {
          body.innerHTML = '<p class="cart-drawer__empty">Il tuo carrello è vuoto.</p>';
          if (foot) foot.hidden = true;
          return cart;
        }

        body.innerHTML = cart.items.map(function (item) {
          var img = item.image ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_160x$1') + '" alt="" width="64" height="64">' : '<span></span>';
          var plan = item.selling_plan_allocation ? '<div class="cart-line__meta">' + item.selling_plan_allocation.selling_plan.name + '</div>' : '';
          return '<div class="cart-line">' + img +
            '<div><div class="cart-line__title">' + item.product_title + '</div>' +
            '<div class="cart-line__meta">Q.tà ' + item.quantity + '</div>' + plan + '</div>' +
            '<div class="cart-line__meta">' + money(item.final_line_price) + '</div></div>';
        }).join('');

        if (foot) foot.hidden = false;
        if (totalEl) totalEl.textContent = money(cart.total_price);
        return cart;
      });
  }

  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart().then(openCart);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeCart(); }
  });

  /* ------------------------------------------------------- responsive title */
  function initTitleSize() {
    var title = document.querySelector('.shop-product-title[data-font-size]');
    if (!title) return;
    function apply() {
      var desktop = title.getAttribute('data-font-size');
      var mobile = title.getAttribute('data-mobile-font-size') || desktop;
      title.style.setProperty('font-size', (window.innerWidth <= 799 ? mobile : desktop) + 'px', 'important');
    }
    apply();
    window.addEventListener('resize', apply);
  }

  /* ------------------------------------------------------------------ init */
  function init() {
    initGallery();
    initTitleSize();
    initFaq();
    initBundles();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
